import { labels } from './pt-labels';
export const t = {
    ...labels,
};
//# sourceMappingURL=index.js.map